<template>
    <v-row justify="center">
        <v-dialog
                v-model="dialog"
                eager
                persistent
                transition="dialog-bottom-transition"
                max-width="fit-content">
            <v-card>
                <v-btn
                        class="webcam-capture-btn-top"
                        color="gappt-grey"
                        fab
                        dark
                        absolute
                        top
                        right
                        @click="$emit('close-dialog')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

                <v-btn
                        v-if="!freezed"
                        class="webcam-capture-btn"
                        color="gappt-orange"
                        fab
                        dark
                        absolute
                        bottom
                        right
                        @click="freeze">
                    <v-icon>mdi-camera</v-icon>
                </v-btn>

                <v-btn
                        v-if="!freezed && isMobile"
                        class="webcam-capture-btn"
                        color="gappt-grey"
                        fab
                        dark
                        absolute
                        bottom
                        left
                        @click="rotate">
                    <v-icon>mdi-rotate-3d-variant</v-icon>
                </v-btn>

                <v-btn
                        v-if="!!freezed"
                        class="webcam-capture-btn"
                        color="red"
                        fab
                        dark
                        absolute
                        bottom
                        left
                        @click="unfreeze">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-btn
                        v-if="!!freezed"
                        class="webcam-capture-btn"
                        color="green"
                        fab
                        dark
                        absolute
                        bottom
                        right
                        @click="save">
                    <v-icon>mdi-content-save</v-icon>
                </v-btn>

                <div
                        v-if="!!stencil"
                        class="stencil"
                        :style="'background-image: url(' + stencil + ');'" />
                <div
                        :id="webcamDivId"
                        class="webcam"
                        style="max-width:640px;" />
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
    import Webcam from "webcamjs"

    export default {
        name: "WebcamDialog",
        props: {
            stencil: {type: String, default: ''},
            dialog: {type: Boolean},
            webcamId: {type: String, default: ''},
        },
        data() {
            return {
                freezed: false,
                file: null,
                facingMode: 'user',
            }
        },
        computed: {
            webcamDivId() {
                return 'webcam-' + this.webcamId
            },
            isMobile() {
                let isMobile = RegExp(/Android|webOS|iPhone|iPod|iPad/i)
                    .test(navigator.userAgent);

                if (!isMobile) {
                    const isMac = RegExp(/Macintosh/i).test(navigator.userAgent);

                    if (isMac && navigator.maxTouchPoints && navigator.maxTouchPoints > 2) {
                        isMobile = true;
                    }
                }
                return isMobile;
            },
        },
        watch: {
            dialog() {
                if (this.dialog) {
                    this.setWebcam();
                } else {
                    Webcam.reset();
                }
            }
        },
        mounted() {
            window.addEventListener('orientationchange', () => {
                if (this.dialog) {
                    this.$emit('close-dialog');
                    Webcam.reset();
                    this.setWebcam();
                    this.$emit('open-dialog');
                }
            });
        },
        methods: {
            rotate() {
                Webcam.reset();
                if (this.facingMode === 'user') {
                    this.facingMode = 'environment'
                } else {
                    this.facingMode = 'user'
                }
                this.setWebcam();
            },
            webcamResolution() {
                let width = 640;
                let height = 480;
                let dimension = height / width;
                let screenW = window.screen.availWidth;
                let screenH = window.screen.availHeight;

                if (screenW < width) {
                    width = screenW - 48;
                    height = width * dimension;
                }

                if (screenH < height) {
                    height = screenH - 48;
                    width = height / dimension;
                }

                if (screenW < screenH) {
                    return [height, width]
                }

                return [width, height]
            },
            webcamWidth() {
                return this.webcamResolution()[0]
            },

            webcamHeight() {
                return this.webcamResolution()[1]
            },
            freeze() {
                this.freezed = true;
                Webcam.freeze();
            },
            unfreeze() {
                this.freezed = false;
                Webcam.unfreeze();
            },
            save() {
                Webcam.snap((file) => {
                    this.file = file;
                    this.freezed = false;
                    this.$emit('photo-saved', this.file);
                    this.$emit('close-dialog');
                })
            },
            setWebcam() {
                Webcam.set({
                    width: this.webcamWidth(),
                    height: this.webcamHeight(),
                    dest_width: this.webcamWidth(),
                    dest_height: this.webcamHeight(),
                    image_format: 'jpeg',
                    jpeg_quality: 90,
                    flip_horiz: this.facingMode === 'user',
                    fps: 60,
                    constraints: {
                        facingMode: this.facingMode
                    }
                });
                Webcam.attach('#' + this.webcamDivId);
                var originalAlert = window.alert;

                window.alert = function(message) {
                    if (message.startsWith("Webcam.js Error: ")) {
                        originalAlert("Please check and enable camera permissions in your browser settings to continue using this feature.");
                    } else {
                        originalAlert(message);
                    }
                };
            }
        }
    }
</script>

<style>
	.webcam-capture-btn {
		bottom: 10px !important;
		z-index: 2002 !important;
	}

	.webcam-capture-btn-top {
		top: 10px !important;
		z-index: 2002 !important;
	}

	.stencil {
		width: 100%;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 100%;
		position: absolute;
		z-index: 2000;
	}

	.webcam {
		overflow: auto !important;
	}

	.v-dialog {
		overflow-y: hidden;
	}
</style>